import { render, staticRenderFns } from "./SubCategoriesList.vue?vue&type=template&id=27b10f30&scoped=true"
import script from "./SubCategoriesList.vue?vue&type=script&lang=js"
export * from "./SubCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b10f30",
  null
  
)

export default component.exports